var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('analyses-tabs',{attrs:{"farmAnalysisList":_vm.farmAnalysisList,"analysis":_vm.analysis,"source":_vm.source}})}
var staticRenderFns = []

export { render, staticRenderFns }